



















































































import { Component, PropSync, Vue } from "vue-property-decorator";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import { producto } from "@/shared/dtos/producto";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import productoModule from "@/store/modules/producto-module";
import { MessageService } from "@/shared/services/message-service";
import { ProcessoNums } from "./ProcessoNums";
import datos_adicionales_productoModule from "@/store/modules/datos_adicionales_producto-module";
import { datos_adicionales_producto } from "@/shared/dtos/datos_adicionales_producto";
import { UtilsString } from "@/utils/utils-string";
@Component({
  components: {
    ConfirmDialog,
  },
})
export default class ProcesoReserva extends Vue {
  @PropSync("id", { default: -1 }) id_prodcuto!: number;
  @PropSync("show", { default: false }) Xshow!: boolean;
  public selectedRow: producto = new producto();
  public persona_reserva: string = "";
  public _datos_adicionales: datos_adicionales_producto =
    new datos_adicionales_producto();

  async created() {
    if (!(productoModule.productos.length > 0)) {
      await productoModule.getproductos();
    }
    this.selectedRow = productoModule.productos.find(
      (x) => x.id == this.id_prodcuto
    ) || new producto();
    await datos_adicionales_productoModule.getdatos_adicionales_productoById(
      this.selectedRow.id
    );

    this._datos_adicionales =
      datos_adicionales_productoModule.datos_adicionales_producto;
    this.persona_reserva = UtilsString.ValueOf(this._datos_adicionales.texto);
  }

  get Ganacias() {
    return (
      this.selectedRow.precio_vendido - this.selectedRow.coste_compra
    ).toFixed(2);
  }
  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
  async aceptar() {
    this.selectedRow.estado = ProcessoNums.Reservado;
    this.selectedRow.fecha_venta = new Date();

    this._datos_adicionales.tipo_registro = ProcessoNums.Reservado;
    this._datos_adicionales.id_prodcuto = this.selectedRow.id;
    this._datos_adicionales.texto = this.persona_reserva;

    if (this._datos_adicionales.id > 0) {
      await datos_adicionales_productoModule.modificardatos_adicionales_producto(
        this._datos_adicionales
      );
    } else {
      await datos_adicionales_productoModule.guardardatos_adicionales_producto(
        this._datos_adicionales
      );
    }
    productoModule.modificarproducto(this.selectedRow).then(() => {
      this.cancelar();
      MessageService.toast("Reservado");
      productoModule.getproductos();
    });
  }
  cancelar() {
    this.Xshow = false;
  }
}
